import { memo } from 'react'
import classNames from 'classnames'
import { Icon } from '@winnin/ds-icon'

import type { ICollapsibleDropdownProps } from './collapsible-dropdown.types'
import './collapsible-dropdown.styles.scss'

export const CollapsibleDropdownView = memo(
  ({ trigger, children, dropdownContentClasses, isOpen, onToggle, className }: ICollapsibleDropdownProps) => {
    return (
      <div className={classNames('CollapsibleDropdown', className)}>
        {isOpen && <div className="CollapsibleDropdown__overlay" onClick={onToggle} aria-hidden="true" />}
        <button type="button" className="CollapsibleDropdown__trigger" onClick={onToggle} aria-expanded={isOpen}>
          {trigger}
          <Icon name={isOpen ? 'chevronUp' : 'chevronDown'} width={10} height={10} color="var(--gray_dark2)" />
        </button>
        {isOpen && <div className={classNames('CollapsibleDropdown__content', dropdownContentClasses)}>{children}</div>}
      </div>
    )
  }
)
